import { defineStore } from 'pinia';
import { authApi, type AdminProfile } from '@/api/auth';
import { extractErrorMessage } from '@/api/client';

interface AuthState {
	admin: AdminProfile | null;
	loading: boolean;
	error: string | null;
	initialized: boolean;
}

export const useAuthStore = defineStore('auth', {
	state: (): AuthState => ({
		admin: null,
		loading: false,
		error: null,
		initialized: false
	}),

	getters: {
		isAuthenticated: state => state.admin !== null
	},

	actions: {
		async fetchMe(): Promise<void> {
			if (this.initialized && this.admin) return;
			this.loading = true;
			try {
				this.admin = await authApi.me();
			} finally {
				this.loading = false;
				this.initialized = true;
			}
		},

		async login(email: string, password: string): Promise<boolean> {
			this.loading = true;
			this.error = null;
			try {
				this.admin = await authApi.login(email, password);
				this.initialized = true;
				return true;
			} catch (error) {
				this.error = extractErrorMessage(error);
				return false;
			} finally {
				this.loading = false;
			}
		},

		async logout(): Promise<void> {
			try {
				await authApi.logout();
			} catch {
				// silent — даже если запрос упал, локальное состояние сбросим
			}
			this.admin = null;
		}
	}
});
